module.exports = __webpack_public_path__ + "static/media/costcase3.43f53997.png";